module.exports = __webpack_public_path__ + "img/KarimKaka-Nil.987835a3.jpg";